<template>
  <div class="hello">
    <h1>You love strong magic.</h1>
    <img alt="Blank Billets" src="../assets/step1.jpg" style="width:100vw">

    <h1>With cutting-edge methods.</h1>

    <img alt="Blank Billets" src="../assets/step2.jpg" style="width:100vw">
    <h1>For professionals only:</h1>
    <img alt="Blank Billets" src="../assets/step3.jpg" style="width:100vw">

    <h1>She takes the cards home.</h1>

    <img alt="Blank Billets" src="../assets/step4.jpg" style="width:100vw">

    <h1>And destroys them...</h1>
    <img alt="Blank Billets" src="../assets/step5.jpg" style="width:100vw">
    <h1>Until one remains.</h1>
    <img alt="Blank Billets" src="../assets/step6.jpg" style="width:100vw">
    <h1>Then, she calls you.</h1>
    <img alt="Blank Billets" src="../assets/Women_on_a_phone.jpg" style="width:100vw">

    <h1>But you already know which one she chose.</h1>

    <img alt="Blank Billets" src="../assets/greece.jpg" style="width:100vw">
    <h1>
      Now that's...
      <br>
      <br>a fucking good magic trick.
    </h1>

    <h3>Details:</h3>
    <ul>
      <!-- <li>$200 Inititiation Fee (includes 6 months tracking)</li>
      <li>$9 per month to maintain billet tracking</li>-->
    </ul>
    <h1 style="padding-bottom:40px">Inventory is extremely limited</h1>
    <form v-on:submit.prevent="joinWaitlist(email, phone)">
      <input v-model="phone" type="tel" placeholder="phone" style="width:200px;font-size:2em">
      <input
        v-on:keyup.enter="joinWaitlist(email, phone)"
        v-model="email"
        type="email"
        placeholder="e-mail"
        required
        style="width:200px;font-size:2em"
      >
      <!-- <input type="submit" value="Order" disabled> -->
      <br>
      <br>
      <button class="button-buy" type="submit">Reserve Now</button>
    </form>
    <br>
    <br>
    <br>

        <h1> Best paired with <br> <a href ="https://afuckinggoodpeek.com">A fucking good peek</a></h1>

  </div>
</template>

<script>
// import Parallax from "vue-parallaxy";
// import VideoBg from "vue-videobg";
import { db, gtag } from "../main";

export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: {
    // Parallax
    // VideoBg
  },
  data() {
    return {
      email: "",
      phone: ""
    };
  },
  methods: {
    joinWaitlist(email, phone) {
      const createdAt = new Date();
      db.collection("waitlist").add({ email, phone, createdAt });
      // Clear values
      this.email = "You're in!";
      this.phone = "";
      gtag("event", "signed up");
      this.$router.push("orders")
    },
    buyEarlyBird() {
      // stripe
      //   .redirectToCheckout({
      //     items: [
      //       // Replace with the ID of your SKU
      //       { sku: "sku_EzvARrQ3qGHBLn", quantity: 1 }
      //       // { plan: "plan_EzvEKjAGSSV7K1", quantity: 1 }
      //     ],
      //     successUrl: "https://afuckinggoodmagictrick.com/success",
      //     cancelUrl: "https://afuckinggoodmagictrick.com/cancel",
      //     customerEmail: email
      //   })
      //   .then(result => {
      //     alert(result);

      //     // If `redirectToCheckout` fails due to a browser or network
      //     // error, display the localized error message to your customer
      //     // using `result.error.message`.
      //   });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  /* list-style-type: none; */
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
div {
  padding-bottom: 100px;
}

h1 {
  font-size: 3em;
  padding-bottom: 100px;
  padding-top: 100px;
}
/* Image Parallax Section*/

.ParallaxImage {
  background-attachment: fixed;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 50px;
  padding-top: 50px;
}
.ParallaxImage h1 {
  text-align: center;
}
.ParallaxImage h3 {
  font-weight: 700;
  font-size: 76px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
}

/* .bg1 {
  background-image: url("../images/paxallax1.jpg");
}
.bg2 {
  background-image: url("../images/paxallax2.jpg");
}
.bg3 {
  background-image: url("../images/paxallax3.jpg");
}
 */

/* Content Parallax Section*/
.ParallaxContent {
  background: none repeat scroll 0 0 #2581e8;
  padding: 42px 0;
  color: #fff;
}
.ParallaxContent h3 {
  color: #fff;
  text-align: center;
}

/* Video Parallax Section*/
.ParallaxVideo {
  height: 300px;
  padding-bottom: 50px;
  padding-top: 50px;
}
.ParallaxVideo video {
  min-width: 100%;
  position: fixed;
  top: 0;
  z-index: -9999;
}
.ParallaxVideo h3 {
  color: #fff;
  font-size: 76px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
}
.button-buy,
.button-error,
.button-warning,
.button-secondary {
  color: white;
  border-radius: 4px;
  width: 200px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

.button-buy {
  font-size: 2em;
  background: rgb(66, 142, 255); /* this is a green */
}

.button-error {
  background: rgb(202, 60, 60); /* this is a maroon */
}

.button-warning {
  background: rgb(223, 117, 20); /* this is an orange */
}

.button-secondary {
  background: rgb(66, 184, 221); /* this is a light blue */
}
</style>
